/* eslint-disable prettier/prettier */
import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { StyleSheet, css } from "aphrodite";
import PropTypes from "prop-types";

function DashboardDisable({ message }) {
  const styles = StyleSheet.create({
    container: {
      // minHeight: "100vh",
      background: "linear-gradient(135deg, #f8f8faff 0%, #f8f8faff 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    },
    paper: {
      maxWidth: "600px",
      width: "100%",
      padding: "48px 40px",
      borderRadius: "24px",
      background: "rgba(255, 255, 255, 0.98)",
      backdropFilter: "blur(10px)",
      textAlign: "center",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
      "@media (max-width: 768px)": {
        padding: "32px 24px",
      },
    },
    topBorder: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "6px",
      background: "linear-gradient(90deg, #0b2c8a 0%, #4a90e2 100%)",
    },
    iconContainer: {
      width: "80px",
      height: "80px",
      margin: "0 auto 24px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #0b2c8a 0%, #4a90e2 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 8px 24px rgba(11, 44, 138, 0.25)",
      animation: "pulse 2s ease-in-out infinite",
    },
    "@keyframes pulse": {
      "0%, 100%": {
        transform: "scale(1)",
        boxShadow: "0 8px 24px rgba(11, 44, 138, 0.25)",
      },
      "50%": {
        transform: "scale(1.05)",
        boxShadow: "0 12px 32px rgba(11, 44, 138, 0.35)",
      },
    },
    lockIcon: {
      width: "40px",
      height: "40px",
      color: "white",
    },
    title: {
      fontWeight: 700,
      color: "#0b2c8a",
      marginBottom: "16px",
      fontSize: "28px",
      "@media (max-width: 768px)": {
        fontSize: "24px",
      },
    },
    message: {
      color: "#555",
      fontSize: "16px",
      lineHeight: "1.7",
      marginBottom: "24px",
      "@media (max-width: 768px)": {
        fontSize: "15px",
      },
    },
    infoBox: {
      background: "rgba(11, 44, 138, 0.05)",
      border: "1px solid rgba(11, 44, 138, 0.1)",
      borderRadius: "12px",
      padding: "16px",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      marginTop: "24px",
    },
    infoIcon: {
      width: "20px",
      height: "20px",
      color: "#0b2c8a",
      flexShrink: 0,
      marginTop: "2px",
    },
    infoText: {
      color: "#f50c0cff",
      fontSize: "20px",
      textAlign: "left",
      lineHeight: "1.6",
      margin: 0,
    },
    footer: {
      color: "#999",
      marginTop: "32px",
      fontSize: "13px",
    },
  });

  return (
    <Box className={css(styles.container)}>
      <Paper elevation={8} className={css(styles.paper)}>
        <div className={css(styles.topBorder)} />

        {/* Icon Container */}
        <div className={css(styles.iconContainer)}>
          <svg
            className={css(styles.lockIcon)}
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        {/* Title */}
        <Typography variant="h4" className={css(styles.title)}>
          {message || "The dashboard is currently disabled for maintenance."}
        </Typography>

        {/* Message */}
        {/* <Typography variant="body1" className={css(styles.message)}>
          The dashboard will be unavailable for a short time, but everything
          else is working normally. Thanks for your patience.
        </Typography> */}

        {/* Info Box */}
        <div className={css(styles.infoBox)}>
          <svg
            className={css(styles.infoIcon)}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          <p className={css(styles.infoText)}>
            The dashboard is temporarily unavailable, but all other site
            features remain fully operational.
          </p>
        </div>

        {/* Footer Text */}
        <Typography variant="caption" className={css(styles.footer)}>
          Thank you for your patience
        </Typography>
      </Paper>
    </Box>
  );
}

DashboardDisable.propTypes = {
  message: PropTypes.string,
};

DashboardDisable.defaultProps = {
  message: "",
};

export default DashboardDisable;
